
const digest = '1f0b7e50488d58746c41e8b3e18a7772d91968aed220bd2529f7949443aa0d45';
const css = `._commandMenuItem_14z45_1 {
  display: contents; /* Let the natural display of children (implicit in aha-menu-item) take over. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItem":"_commandMenuItem_14z45_1"};
export { css, digest };
  